module.exports = "<th>Срок аренды</th>\n<td>\n  <div class=\"filter__button-group\">\n    <!-- Если ничего не выбрано, то любая длительная (!1) -->\n    <term\n      ng-repeat=\"item in ::terms.for_day_long\"\n      source=\"source.for_day\"\n      behavior=\"radio\"\n      text=\"{$ ::item.text $}\"\n      ng-value=\"::item.value\"\n      default-value=\"!1\"\n      />\n  </div>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/for_day.html
// module id = 344
// module chunks = 0